module.exports = __webpack_public_path__ + "staticVue/img/game_list03.fdd358f5.jpg";